var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.forceUpdateFlag
    ? _c(
        "div",
        { staticClass: "root-container" },
        [
          _c(
            "grid-layout",
            {
              ref: "gridlayout",
              staticClass: "gridlayout",
              attrs: {
                layout: _vm.viewLayout,
                "col-num": _vm.cols,
                responsive: _vm.responsive,
                "row-height": 30,
                "is-draggable": false,
                "is-resizable": true,
                "vertical-compact": true,
                "use-css-transforms": false,
              },
              on: {
                "update:layout": function ($event) {
                  _vm.viewLayout = $event
                },
              },
            },
            _vm._l(_vm.viewLayout, function (item) {
              return _c(
                "grid-item",
                {
                  key: item._id,
                  style: {
                    background:
                      item.styleConfig &&
                      item.styleConfig.commongConfig.customBackgroundColor
                        ? item.styleConfig.commongConfig.backgroundColor
                        : "#fff",
                  },
                  attrs: {
                    "drag-allow-from": ".bi-layout-drag-handle",
                    static: _vm.getPreviewFlag,
                    x: item.x,
                    y: item.y,
                    w: item.w,
                    h: item.h,
                    "drag-ignore-from": ".jzliu-bi-engine-middle-layer",
                    i: item.i,
                  },
                  on: {
                    resized: function ($event) {
                      return _vm.resizedEvent(item)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "jzliu-bi-engine-chart-warp grid-warp" },
                    [
                      _c("middle-layer", {
                        attrs: {
                          dashboardName: _vm.dashboardName,
                          chartDirection: _vm.chartDirection,
                          chartPreviewMode: _vm.chartPreviewMode,
                          previewMode: _vm.previewMode,
                          chartData: item,
                        },
                        on: {
                          "sort-change": _vm.handleSortChange,
                          "drill-item-click": function (data) {
                            return _vm.handleDrillItemClick(data, item)
                          },
                          "handle-table-command": function (command) {
                            return _vm.handleTableCommand(command, item)
                          },
                          "table-page-change": _vm.handleTablePageChange,
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.chartSelect(item)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "gap" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }